function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React, { useRef, useEffect } from 'react';
import { useExtractedMargins, useMantineTheme, Text } from '@mantine/core';
import { upperFirst } from '@mantine/hooks';
import dayjs from 'dayjs';
import { getMonthDays } from '../../utils/get-month-days/get-month-days.js';
import { getWeekdaysNames } from '../../utils/get-weekdays-names/get-weekdays-names.js';
import { isSameMonth } from '../../utils/is-same-month/is-same-month.js';
import { Day } from './Day/Day.js';
import { getDayProps } from './get-day-props/get-day-props.js';
import useStyles from './Month.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var noop = function noop() {};
function Month(_a) {
  var _b = _a,
    className = _b.className,
    style = _b.style,
    month = _b.month,
    value = _b.value,
    onChange = _b.onChange,
    _b$autoFocus = _b.autoFocus,
    autoFocus = _b$autoFocus === void 0 ? false : _b$autoFocus,
    _b$disableOutsideEven = _b.disableOutsideEvents,
    disableOutsideEvents = _b$disableOutsideEven === void 0 ? false : _b$disableOutsideEven,
    locale = _b.locale,
    dayClassName = _b.dayClassName,
    dayStyle = _b.dayStyle,
    _b$disableOutsideDayS = _b.disableOutsideDayStyle,
    disableOutsideDayStyle = _b$disableOutsideDayS === void 0 ? false : _b$disableOutsideDayS,
    classNames = _b.classNames,
    styles = _b.styles,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    excludeDate = _b.excludeDate,
    onDayMouseEnter = _b.onDayMouseEnter,
    range = _b.range,
    _b$hideWeekdays = _b.hideWeekdays,
    hideWeekdays = _b$hideWeekdays === void 0 ? false : _b$hideWeekdays,
    _b$__staticSelector = _b.__staticSelector,
    __staticSelector = _b$__staticSelector === void 0 ? "Month" : _b$__staticSelector,
    _b$size = _b.size,
    size = _b$size === void 0 ? "sm" : _b$size,
    _b$fullWidth = _b.fullWidth,
    fullWidth = _b$fullWidth === void 0 ? false : _b$fullWidth,
    _b$preventFocus = _b.preventFocus,
    preventFocus = _b$preventFocus === void 0 ? false : _b$preventFocus,
    sx = _b.sx,
    _b$firstDayOfWeek = _b.firstDayOfWeek,
    firstDayOfWeek = _b$firstDayOfWeek === void 0 ? "monday" : _b$firstDayOfWeek,
    others = __objRest(_b, ["className", "style", "month", "value", "onChange", "autoFocus", "disableOutsideEvents", "locale", "dayClassName", "dayStyle", "disableOutsideDayStyle", "classNames", "styles", "minDate", "maxDate", "excludeDate", "onDayMouseEnter", "range", "hideWeekdays", "__staticSelector", "size", "fullWidth", "preventFocus", "sx", "firstDayOfWeek"]);
  var _useStyles = useStyles({
      fullWidth: fullWidth
    }, {
      sx: sx,
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useExtractedMargins = useExtractedMargins({
      others: others,
      style: style
    }),
    mergedStyles = _useExtractedMargins.mergedStyles,
    rest = _useExtractedMargins.rest;
  var theme = useMantineTheme();
  var finalLocale = locale || theme.datesLocale;
  var daysRefs = useRef({});
  var days = getMonthDays(month, firstDayOfWeek);
  var focusDay = function focusDay(date, diff) {
    var offset = new Date(date);
    offset.setDate(date.getDate() + diff);
    if (offset.toISOString() in daysRefs.current) {
      if (!(!isSameMonth(month, offset) && disableOutsideEvents)) {
        daysRefs.current[offset.toISOString()].focus();
      }
    }
  };
  var handleKeyDown = function handleKeyDown(currentDate, event) {
    var code = event.nativeEvent.code;
    if (code === "ArrowUp") {
      event.preventDefault();
      focusDay(currentDate, -7);
    }
    if (code === "ArrowDown") {
      event.preventDefault();
      focusDay(currentDate, 7);
    }
    if (code === "ArrowRight") {
      event.preventDefault();
      currentDate.getDay() !== 0 && focusDay(currentDate, 1);
    }
    if (code === "ArrowLeft") {
      event.preventDefault();
      currentDate.getDay() !== 1 && focusDay(currentDate, -1);
    }
  };
  useEffect(function () {
    if (autoFocus) {
      var date = new Date(month.getFullYear(), month.getMonth(), value ? value.getDate() : 1).toISOString();
      if (date in daysRefs.current) {
        daysRefs.current[date].focus();
      }
    }
  }, []);
  var weekdays = getWeekdaysNames(finalLocale, firstDayOfWeek).map(function (weekday) {
    return /* @__PURE__ */React.createElement("th", {
      className: classes.weekdayCell,
      key: weekday
    }, /* @__PURE__ */React.createElement(Text, {
      size: size,
      className: classes.weekday
    }, upperFirst(weekday)));
  });
  var hasValue = value instanceof Date;
  var hasValueInMonthRange = hasValue && dayjs(value).isAfter(dayjs(month).startOf("month")) && dayjs(value).isBefore(dayjs(month).endOf("month"));
  var rows = days.map(function (row, rowIndex) {
    var cells = row.map(function (date, cellIndex) {
      var dayProps = getDayProps({
        date: date,
        month: month,
        hasValue: hasValue,
        minDate: minDate,
        maxDate: maxDate,
        value: value,
        excludeDate: excludeDate,
        disableOutsideEvents: disableOutsideEvents,
        range: range
      });
      var withoutStylesOutsideMonth = disableOutsideDayStyle && dayProps.outside;
      return /* @__PURE__ */React.createElement("td", {
        className: classes.cell,
        key: cellIndex
      }, /* @__PURE__ */React.createElement(Day, {
        ref: function ref(button) {
          daysRefs.current[date.toISOString()] = button;
        },
        onClick: function onClick() {
          return typeof onChange === "function" && onChange(date);
        },
        onMouseDown: function onMouseDown(event) {
          return preventFocus && event.preventDefault();
        },
        value: date,
        outside: dayProps.outside,
        weekend: dayProps.weekend,
        inRange: dayProps.inRange && !withoutStylesOutsideMonth,
        firstInRange: dayProps.firstInRange,
        lastInRange: dayProps.lastInRange,
        firstInMonth: cellIndex === 0 && rowIndex === 0,
        selected: (dayProps.selected || dayProps.selectedInRange) && !withoutStylesOutsideMonth,
        hasValue: hasValueInMonthRange,
        onKeyDown: handleKeyDown,
        className: typeof dayClassName === "function" ? dayClassName(date, dayProps) : null,
        style: typeof dayStyle === "function" ? dayStyle(date, dayProps) : null,
        styles: styles,
        classNames: classNames,
        disabled: dayProps.disabled,
        __staticSelector: __staticSelector,
        onMouseEnter: typeof onDayMouseEnter === "function" ? onDayMouseEnter : noop,
        size: size,
        fullWidth: fullWidth
      }));
    });
    return /* @__PURE__ */React.createElement("tr", {
      key: rowIndex
    }, cells);
  });
  return /* @__PURE__ */React.createElement("table", __spreadValues({
    className: cx(classes.root, className),
    style: mergedStyles
  }, rest), !hideWeekdays && /* @__PURE__ */React.createElement("thead", null, /* @__PURE__ */React.createElement("tr", null, weekdays)), /* @__PURE__ */React.createElement("tbody", null, rows));
}
Month.displayName = "@mantine/core/Month";
export { Month };